import { axiosInstance } from "../../apiConfing/instance";
import { SupportMessage } from "./models";

export const supportService = async (message: SupportMessage) => {
  return await axiosInstance.post("/support/message/send", { message });
};
